module.exports = __webpack_public_path__ + "static/media/java.dd071c0b.svg";